import SurveyTemplate from './src/main';

/* istanbul ignore next */
SurveyTemplate.install = function(Vue) {
  Vue.component(SurveyTemplate.name, SurveyTemplate);
};

export default SurveyTemplate;
